module.exports = __webpack_public_path__ + "2e3a5c253d9178ef171bec5bc5fae073.pdf";